import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { ToastService } from 'services/toast-service';
import { RingSinkerFloaterConnectionTypeService } from 'services/ring-sinker-floater-connection-type-service';

@autoinject
export class RingSinkerFloaterConnectionTypeList {
  private tableData: Array<Models.RingSinkerFloaterConnectionType>;
  private activeTableRow: number;

  private constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private ringSinkerFloaterConnectionTypeService: RingSinkerFloaterConnectionTypeService
  ) {}

  private activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  private attached(params) {
    this.eventAggregator.subscribe('ringSinkerFloaterConnectionTypeListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  private updateView() {
    this.ringSinkerFloaterConnectionTypeService
      .getAll()
      .then((res) => {
        this.tableData = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('ring-sinker-floater-connection-type-detail', { Id: id });
  }
}
